import { supabase } from './supabase';

const API_BASE = '/api';

async function authHeader(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  if (!data.session) return {};
  return { Authorization: `Bearer ${data.session.access_token}` };
}

async function throwWithBody(path: string, res: Response): Promise<never> {
  let detail = '';
  try {
    const text = await res.text();
    if (text) {
      try {
        const j = JSON.parse(text);
        detail = j.message || j.error || text;
      } catch {
        detail = text;
      }
    }
  } catch { /* ignore */ }
  throw new Error(`API ${path} → ${res.status}${detail ? `: ${detail}` : ''}`);
}

export async function apiGet<T>(path: string): Promise<T> {
  const headers = await authHeader();
  const res = await fetch(`${API_BASE}${path}`, { headers });
  if (!res.ok) await throwWithBody(path, res);
  return res.json();
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  const headers = await authHeader();
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) await throwWithBody(path, res);
  return res.json();
}
